export const personNameCharacters = (value) => {
    // La regex : À-ž permet de matcher les caractères accentués (minuscule et majuscule)
    // Le caractère ’ doit être autorisé pour la saisie sur IOS
    const regex = new RegExp(/^[a-zA-ZÀ-ž]([a-zA-ZÀ-ž-'’ ]{0,48}[a-zA-ZÀ-ž])?$/i);
    if (value && regex.test(value)) {
        return true;
    }
    return "Saisie limitée aux caractères suivants : lettres, tiret (-), espace ( ) et apostrophe (') au milieu du nom.";
};
